import React from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';

const Checkbox = ({ key, onclick = null }) => (
    <div className={css.component}>
        <input id={key} onClick={onclick} type="checkbox" />
    </div>
);

Checkbox.propTypes = {
    key: PropTypes.string,
    onclick: PropTypes.func
};

export default Checkbox;



// WEBPACK FOOTER //
// ./app/components/checkbox/index.js